.screen {
  background: var(--color-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  animation: evx-fadeUp 0.3s ease both;
}
.card {
  width: 520px;
  padding: 40px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}
.status {
  font-size: 12px;
  font-weight: 700;
  color: var(--color-danger);
  animation: evx-blink 0.9s infinite;
}
.title {
  margin: 0;
  font-size: 44px;
  font-weight: 800;
  color: var(--color-text);
}
.reason {
  padding: 10px 22px;
  background: var(--color-danger-100);
  color: var(--color-danger-700);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 15px;
}
.unconfirmed {
  padding: 12px 18px;
  background: var(--color-danger);
  color: #ffffff;
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 15px;
  line-height: 1.4;
  animation: evx-blink 1.2s infinite;
}
.note {
  max-width: 420px;
  font-size: 14px;
  color: var(--color-neutral-700);
  font-weight: 600;
}
.actions {
  display: flex;
  gap: 14px;
  margin-top: 10px;
}
